import './HomePageHeader.css'
import { useEffect, useState} from 'react'
import { Link } from 'react-router-dom';

const HomePageHeader = ({BackgroundUrl,divDetails}) => {

  const [showSidebar, setShowSidebar]=useState(false);

  const handleScroller = () => {
    setShowSidebar(false);
}

  useEffect(() => {
    window.addEventListener('scroll', handleScroller, { passive: true });
    return () => {
        window.removeEventListener('scroll', handleScroller);
    };
  }, [])
    
    return (

        <div className="main-header" style={{ backgroundImage:`linear-gradient(45deg,
                                                              rgba(0, 0, 0, 0.36),
                                                              rgba(0, 0, 0, 0.36)), url(${BackgroundUrl})`}}>

          <header className="header-section">
            <div className='header-logo'>
                <Link to="/"><img src={'../../../../images/chitkara-logo.svg'} alt="logo" /></Link>
                <img onClick={() => setShowSidebar(!showSidebar)} class="hamburger-icon" src='../../../../images/hamburger-icon.svg' alt="logo" />
            </div>

            <div className="header-navbar">
                  <ul className="nav nav-pill">
                    <li className="nav-item">
                      <Link to="/UpCommingEvents" class="nav-link">Upcoming Events</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/PastEvents" class="nav-link">Past Events</Link>
                    </li>
                    <li className="nav-item"> 
                      <Link to="/auth/login" class="nav-link">Login</Link>
                    </li>
                  </ul>
            </div>  
          </header>     

          {showSidebar &&
            <div className="mobile-navbar">
              <div className='mobile-logo'>
                <a href="#"><img src={'../../../../images/mobile-sidebar-logo.svg'} alt="logo" /></a>
              </div>
                  <ul className="nav nav-pill">
                    <li className="nav-item">
                      <img src={'../../../../images/application-icon.svg'} alt="logo" />
                      <Link to="/UpCommingEvents" class="nav-link">Upcoming Events</Link>
                    </li>
                    <li className="nav-item">
                      <img src={'../../../../images/application-icon.svg'} alt="logo" />
                      <Link to="/PastEvents" class="nav-link">Past Events</Link>
                    </li>
                    <li className="nav-item">
                      <img src={'../../../../images/application-icon.svg'} alt="logo" />
                      <Link to="/auth/login" class="nav-link">Login</Link>
                    </li>
                  </ul>
               </div>          
        }   

          {divDetails && <div className='header-details'>
            <h1>Events at Chitkara University</h1>
            <div class='header-para'>
              <p>Our online Masters of Business Administration (MBA) program with a concentration
                in Digital Marketing is aimed at equipping students with the analytical & marketing 
                skills and knowledge.</p>
            </div>
          </div>}
        </div>
    );
};

export default HomePageHeader;